import { SUPPRESS_SUCCESS_GROWL, DEFAULT_RPP, STATUS_BAD_REQUEST } from "utils/constants";

const DEFAULT_PAGE = 1;
export const CONTENT_FEEDS_API_GATEWAY_PREFIX = "cfa";
export const FEED_CREATIVE_ADAPTER_GATEWAY_PREFIX = "fca";

export const CONTENT_FEED_ACTIONS = {
	TOGGLE_AUTO_UPDATES_AJAX: "TOGGLE_AUTO_UPDATES_AJAX",
	TOGGLE_AUTO_UPDATES_SUCCESS: "TOGGLE_AUTO_UPDATES_SUCCESS",
	TOGGLE_AUTO_UPDATES_ERROR: "TOGGLE_AUTO_UPDATES_ERROR",
	TOGGLE_CREATIVE_AUTO_UPDATES_AJAX: "TOGGLE_CREATIVE_AUTO_UPDATES_AJAX",
	TOGGLE_CREATIVE_AUTO_UPDATES_SUCCESS: "TOGGLE_CREATIVE_AUTO_UPDATES_SUCCESS",
	TOGGLE_CREATIVE_AUTO_UPDATES_ERROR: "TOGGLE_CREATIVE_AUTO_UPDATES_ERROR",
	FETCH_ASSIGNED_CREATIVES_AJAX: "FETCH_ASSIGNED_CREATIVES_AJAX",
	FETCH_ASSIGNED_CREATIVES_SUCCESS: "FETCH_ASSIGNED_CREATIVES_SUCCESS",
	FETCH_ASSIGNED_CREATIVES_ERROR: "FETCH_ASSIGNED_CREATIVES_ERROR",
	FETCH_UPDATES_HISTORY_AJAX: "FETCH_UPDATES_HISTORY_AJAX",
	FETCH_UPDATES_HISTORY_SUCCESS: "FETCH_UPDATES_HISTORY_SUCCESS",
	FETCH_UPDATES_HISTORY_ERROR: "FETCH_UPDATES_HISTORY_ERROR",
	REFRESH_CONTENT_FEED_AJAX: "REFRESH_CONTENT_FEED_AJAX",
	REFRESH_CONTENT_FEED_SUCCESS: "REFRESH_CONTENT_FEED_SUCCESS",
	REFRESH_CONTENT_FEED_ERROR: "REFRESH_CONTENT_FEED_ERROR",
	FETCH_CONTENT_FEED_SHEETS_AJAX: "FETCH_CONTENT_FEED_SHEETS_AJAX",
	FETCH_CONTENT_FEED_SHEETS_SUCCESS: "FETCH_CONTENT_FEED_SHEETS_SUCCESS",
	FETCH_CONTENT_FEED_SHEETS_ERROR: "FETCH_CONTENT_FEED_SHEETS_ERROR",
	FETCH_SPREADSHEET_HEADERS_AJAX: "FETCH_SPREADSHEET_HEADERS_AJAX",
	FETCH_SPREADSHEET_HEADERS_SUCCESS: "FETCH_SPREADSHEET_HEADERS_SUCCESS",
	FETCH_SPREADSHEET_HEADERS_ERROR: "FETCH_SPREADSHEET_HEADERS_ERROR",
	FETCH_SPREADSHEET_AUTO_MAPPINGS_AJAX: "FETCH_SPREADSHEET_AUTO_MAPPINGS_AJAX",
	FETCH_SPREADSHEET_AUTO_MAPPINGS_SUCCESS: "FETCH_SPREADSHEET_AUTO_MAPPINGS_SUCCESS",
	FETCH_SPREADSHEET_AUTO_MAPPINGS_ERROR: "FETCH_SPREADSHEET_AUTO_MAPPINGS_ERROR",
	CREATE_CONTENT_FEED_AJAX: "CREATE_CONTENT_FEED_AJAX",
	CREATE_CONTENT_FEED_SUCCESS: "CREATE_CONTENT_FEED_SUCCESS",
	CREATE_CONTENT_FEED_ERROR: "CREATE_CONTENT_FEED_ERROR",
};

export function toggleAutoUpdates(feedId, autoUpdate) {
	return {
		type: CONTENT_FEED_ACTIONS.TOGGLE_AUTO_UPDATES_AJAX,
		payload: {
			feedId,
			autoUpdate,
		},
		meta: {
			...SUPPRESS_SUCCESS_GROWL,
			buildMessage: () => ({
				type: "error",
				id: new Date().getTime(),
				messageHeader: `Error ${autoUpdate ? 'enabling' : 'disabling'} auto updates`,
				message: 'Please try again',
			}),
		},
		AJAX: {
			url: `feeds/${feedId}/autoupdate`,
			gateway: CONTENT_FEEDS_API_GATEWAY_PREFIX,
			method: "put",
			params: {
				autoUpdate,
			},
			success: CONTENT_FEED_ACTIONS.TOGGLE_AUTO_UPDATES_SUCCESS,
			error: CONTENT_FEED_ACTIONS.TOGGLE_AUTO_UPDATES_ERROR,
		},
	};
}

export function toggleCreativeAutoUpdates(contentFeedId, idCreative, enableUpdate) {
	return {
		type: CONTENT_FEED_ACTIONS.TOGGLE_CREATIVE_AUTO_UPDATES_AJAX,
		payload: {
			contentFeedId,
			idCreative,
			enableUpdate,
		},
		meta: {
			...SUPPRESS_SUCCESS_GROWL,
			buildMessage: () => ({
				type: "error",
				id: new Date().getTime(),
				messageHeader: `Error ${enableUpdate ? 'enabling' : 'disabling'} creative auto updates`,
				message: 'Please try again',
			}),
		},
		AJAX: {
			url: `creatives-feeds/enable-update`,
			gateway: FEED_CREATIVE_ADAPTER_GATEWAY_PREFIX,
			method: "put",
			data: {
				updates: [{ creativeId: idCreative, enableUpdate }],
			},
			success: CONTENT_FEED_ACTIONS.TOGGLE_CREATIVE_AUTO_UPDATES_SUCCESS,
			error: CONTENT_FEED_ACTIONS.TOGGLE_CREATIVE_AUTO_UPDATES_ERROR,
		},
	};
}

export function fetchAssignedCreatives(contentFeedId) {
	return {
		type: CONTENT_FEED_ACTIONS.FETCH_ASSIGNED_CREATIVES_AJAX,
		meta: SUPPRESS_SUCCESS_GROWL,
		AJAX: {
			url: `creatives-feeds/feed/${contentFeedId}`,
			gateway: FEED_CREATIVE_ADAPTER_GATEWAY_PREFIX,
			success: CONTENT_FEED_ACTIONS.FETCH_ASSIGNED_CREATIVES_SUCCESS,
			error: CONTENT_FEED_ACTIONS.FETCH_ASSIGNED_CREATIVES_ERROR,
		},
	};
}

export function fetchUpdatesHistory(contentFeedId, page = DEFAULT_PAGE, rpp = DEFAULT_RPP) {
	return {
		type: CONTENT_FEED_ACTIONS.FETCH_UPDATES_HISTORY_AJAX,
		meta: SUPPRESS_SUCCESS_GROWL,
		AJAX: {
			url: `feeds/${contentFeedId}/runs`,
			gateway: CONTENT_FEEDS_API_GATEWAY_PREFIX,
			params: {
				page: page - 1,
				page_size: rpp,
			},
			success: CONTENT_FEED_ACTIONS.FETCH_UPDATES_HISTORY_SUCCESS,
			error: CONTENT_FEED_ACTIONS.FETCH_UPDATES_HISTORY_ERROR,
		},
	};
}

const buildRefreshMessage = (response) => {
	let message = "Bulk Sheet is refreshing";
	let messageHeader = "Refresh Successful";
	let type = "success";

	if (!response || response.status >= STATUS_BAD_REQUEST) {
		message = "Failed to refresh Bulk Sheet. Please try again";
		messageHeader = "Refresh Failed";
		type = "error";
	}

	return {
		id: new Date().getTime(),
		type,
		messageHeader,
		message,
	};
};

export function refreshContentFeed(contentFeedId) {
	return (dispatch) => {
		return dispatch({
			type: CONTENT_FEED_ACTIONS.REFRESH_CONTENT_FEED_AJAX,
			AJAX: {
				url: `feeds/`,
				gateway: CONTENT_FEEDS_API_GATEWAY_PREFIX,
				method: "put",
				params: {
					id: contentFeedId,
					manual: true,
				},
				success: CONTENT_FEED_ACTIONS.REFRESH_CONTENT_FEED_SUCCESS,
				error: CONTENT_FEED_ACTIONS.REFRESH_CONTENT_FEED_ERROR,
			},
			meta: {
				buildMessage: buildRefreshMessage,
			},
		});
	};
}

export function fetchSpreadsheetSheets(sourceUrl) {
	return {
		type: CONTENT_FEED_ACTIONS.FETCH_CONTENT_FEED_SHEETS_AJAX,
		meta: SUPPRESS_SUCCESS_GROWL,
		AJAX: {
			url: `api/v1/data-source/google-spreadsheet/sheets?url=${sourceUrl}`,
			version: 0,
			gateway: CONTENT_FEEDS_API_GATEWAY_PREFIX,
			success: CONTENT_FEED_ACTIONS.FETCH_CONTENT_FEED_SHEETS_SUCCESS,
			error: CONTENT_FEED_ACTIONS.FETCH_CONTENT_FEED_SHEETS_ERROR,
		},
	};
}

export function buildSpreadsheetSourceUrl(sourceUrl, sheetId) {
	const parsedUrl = new URL(sourceUrl);
	if (sheetId !== undefined && sheetId !== null && sheetId !== "") {
		parsedUrl.searchParams.set("gid", String(sheetId));
	}
	return parsedUrl.toString();
}

export function fetchSpreadsheetHeaders(sourceUrl, sheetId) {
	return {
		type: CONTENT_FEED_ACTIONS.FETCH_SPREADSHEET_HEADERS_AJAX,
		meta: SUPPRESS_SUCCESS_GROWL,
		AJAX: {
			url: `api/v1/data-source/google-spreadsheet/headers?url=${buildSpreadsheetSourceUrl(sourceUrl, sheetId)}`,
			version: 0,
			gateway: CONTENT_FEEDS_API_GATEWAY_PREFIX,
			success: CONTENT_FEED_ACTIONS.FETCH_SPREADSHEET_HEADERS_SUCCESS,
			error: CONTENT_FEED_ACTIONS.FETCH_SPREADSHEET_HEADERS_ERROR,
		},
	};
}

export function fetchSpreadsheetAutoMappings(sourceUrl, sheetId) {
	return {
		type: CONTENT_FEED_ACTIONS.FETCH_SPREADSHEET_AUTO_MAPPINGS_AJAX,
		meta: SUPPRESS_SUCCESS_GROWL,
		AJAX: {
			url: `api/v1/data-source/google-spreadsheet/auto-mapping?url=${buildSpreadsheetSourceUrl(sourceUrl, sheetId)}`,
			version: 0,
			gateway: CONTENT_FEEDS_API_GATEWAY_PREFIX,
			success: CONTENT_FEED_ACTIONS.FETCH_SPREADSHEET_AUTO_MAPPINGS_SUCCESS,
			error: CONTENT_FEED_ACTIONS.FETCH_SPREADSHEET_AUTO_MAPPINGS_ERROR,
		},
	};
}

export function createContentFeed(payload) {
	return {
		type: CONTENT_FEED_ACTIONS.CREATE_CONTENT_FEED_AJAX,
		meta: SUPPRESS_SUCCESS_GROWL,
		AJAX: {
			url: "feeds/content",
			gateway: CONTENT_FEEDS_API_GATEWAY_PREFIX,
			method: "post",
			data: payload,
			success: CONTENT_FEED_ACTIONS.CREATE_CONTENT_FEED_SUCCESS,
			error: CONTENT_FEED_ACTIONS.CREATE_CONTENT_FEED_ERROR,
		},
	};
}

